/*! For license information please see client.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("axios"), require("lodash.get"), require("react"), require("react-redux")) : "function" == typeof define && define.amd ? define("header", ["axios", "lodash.get", "react", "react-redux"], t) : "object" == typeof exports ? exports.header = t(require("axios"), require("lodash.get"), require("react"), require("react-redux")) : e.header = t(e[void 0], e.get, e.React, e[void 0]);
}(this, function (e, t, r, n) {
  return function () {
    var o = {
        dqD6: function dqD6(t) {
          "use strict";

          t.exports = e;
        },
        "kpo/": function kpo_(e) {
          "use strict";

          e.exports = t;
        },
        "tMQ+": function tMQ(e) {
          "use strict";

          e.exports = r;
        },
        rCRV: function rCRV(e) {
          "use strict";

          e.exports = n;
        },
        VDhh: function VDhh(e, t, r) {
          var n = r("6lFg").default;
          function o() {
            "use strict";

            e.exports = o = function o() {
              return r;
            }, e.exports.__esModule = !0, e.exports.default = e.exports;
            var t,
              r = {},
              i = Object.prototype,
              a = i.hasOwnProperty,
              s = Object.defineProperty || function (e, t, r) {
                e[t] = r.value;
              },
              u = "function" == typeof Symbol ? Symbol : {},
              l = u.iterator || "@@iterator",
              c = u.asyncIterator || "@@asyncIterator",
              f = u.toStringTag || "@@toStringTag";
            function d(e, t, r) {
              return Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), e[t];
            }
            try {
              d({}, "");
            } catch (t) {
              d = function d(e, t, r) {
                return e[t] = r;
              };
            }
            function p(e, t, r, n) {
              var o = t && t.prototype instanceof S ? t : S,
                i = Object.create(o.prototype),
                a = new U(n || []);
              return s(i, "_invoke", {
                value: b(e, r, a)
              }), i;
            }
            function h(e, t, r) {
              try {
                return {
                  type: "normal",
                  arg: e.call(t, r)
                };
              } catch (e) {
                return {
                  type: "throw",
                  arg: e
                };
              }
            }
            r.wrap = p;
            var y = "suspendedStart",
              m = "suspendedYield",
              g = "executing",
              v = "completed",
              E = {};
            function S() {}
            function T() {}
            function _() {}
            var L = {};
            d(L, l, function () {
              return this;
            });
            var O = Object.getPrototypeOf,
              A = O && O(O(N([])));
            A && A !== i && a.call(A, l) && (L = A);
            var I = _.prototype = S.prototype = Object.create(L);
            function w(e) {
              ["next", "throw", "return"].forEach(function (t) {
                d(e, t, function (e) {
                  return this._invoke(t, e);
                });
              });
            }
            function x(e, t) {
              function r(o, i, s, u) {
                var l = h(e[o], e, i);
                if ("throw" !== l.type) {
                  var c = l.arg,
                    f = c.value;
                  return f && "object" == n(f) && a.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
                    r("next", e, s, u);
                  }, function (e) {
                    r("throw", e, s, u);
                  }) : t.resolve(f).then(function (e) {
                    c.value = e, s(c);
                  }, function (e) {
                    return r("throw", e, s, u);
                  });
                }
                u(l.arg);
              }
              var o;
              s(this, "_invoke", {
                value: function value(e, n) {
                  function i() {
                    return new t(function (t, o) {
                      r(e, n, t, o);
                    });
                  }
                  return o = o ? o.then(i, i) : i();
                }
              });
            }
            function b(e, r, n) {
              var o = y;
              return function (i, a) {
                if (o === g) throw new Error("Generator is already running");
                if (o === v) {
                  if ("throw" === i) throw a;
                  return {
                    value: t,
                    done: !0
                  };
                }
                for (n.method = i, n.arg = a;;) {
                  var s = n.delegate;
                  if (s) {
                    var u = P(s, n);
                    if (u) {
                      if (u === E) continue;
                      return u;
                    }
                  }
                  if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                    if (o === y) throw o = v, n.arg;
                    n.dispatchException(n.arg);
                  } else "return" === n.method && n.abrupt("return", n.arg);
                  o = g;
                  var l = h(e, r, n);
                  if ("normal" === l.type) {
                    if (o = n.done ? v : m, l.arg === E) continue;
                    return {
                      value: l.arg,
                      done: n.done
                    };
                  }
                  "throw" === l.type && (o = v, n.method = "throw", n.arg = l.arg);
                }
              };
            }
            function P(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), E;
              var i = h(o, e.iterator, r.arg);
              if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, E;
              var a = i.arg;
              return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, E) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, E);
            }
            function D(e) {
              var t = {
                tryLoc: e[0]
              };
              1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }
            function R(e) {
              var t = e.completion || {};
              t.type = "normal", delete t.arg, e.completion = t;
            }
            function U(e) {
              this.tryEntries = [{
                tryLoc: "root"
              }], e.forEach(D, this), this.reset(!0);
            }
            function N(e) {
              if (e || "" === e) {
                var r = e[l];
                if (r) return r.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length;) if (a.call(e, o)) return r.value = e[o], r.done = !1, r;
                      return r.value = t, r.done = !0, r;
                    };
                  return i.next = i;
                }
              }
              throw new TypeError(n(e) + " is not iterable");
            }
            return T.prototype = _, s(I, "constructor", {
              value: _,
              configurable: !0
            }), s(_, "constructor", {
              value: T,
              configurable: !0
            }), T.displayName = d(_, f, "GeneratorFunction"), r.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return !!t && (t === T || "GeneratorFunction" === (t.displayName || t.name));
            }, r.mark = function (e) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, d(e, f, "GeneratorFunction")), e.prototype = Object.create(I), e;
            }, r.awrap = function (e) {
              return {
                __await: e
              };
            }, w(x.prototype), d(x.prototype, c, function () {
              return this;
            }), r.AsyncIterator = x, r.async = function (e, t, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new x(p(e, t, n, o), i);
              return r.isGeneratorFunction(t) ? a : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
            }, w(I), d(I, f, "Generator"), d(I, l, function () {
              return this;
            }), d(I, "toString", function () {
              return "[object Generator]";
            }), r.keys = function (e) {
              var t = Object(e),
                r = [];
              for (var n in t) r.push(n);
              return r.reverse(), function e() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in t) return e.value = n, e.done = !1, e;
                }
                return e.done = !0, e;
              };
            }, r.values = N, U.prototype = {
              constructor: U,
              reset: function reset(e) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(R), !e) for (var r in this) "t" === r.charAt(0) && a.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
              },
              stop: function stop() {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function n(n, o) {
                  return s.type = "throw", s.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    s = i.completion;
                  if ("root" === i.tryLoc) return n("end");
                  if (i.tryLoc <= this.prev) {
                    var u = a.call(i, "catchLoc"),
                      l = a.call(i, "finallyLoc");
                    if (u && l) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    } else if (u) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    } else {
                      if (!l) throw new Error("try statement without catch or finally");
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(e, t) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var n = this.tryEntries[r];
                  if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                    var o = n;
                    break;
                  }
                }
                o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                var i = o ? o.completion : {};
                return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, E) : this.complete(i);
              },
              complete: function complete(e, t) {
                if ("throw" === e.type) throw e.arg;
                return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), E;
              },
              finish: function finish(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var r = this.tryEntries[t];
                  if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), E;
                }
              },
              catch: function _catch(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var r = this.tryEntries[t];
                  if (r.tryLoc === e) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      R(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, r, n) {
                return this.delegate = {
                  iterator: N(e),
                  resultName: r,
                  nextLoc: n
                }, "next" === this.method && (this.arg = t), E;
              }
            }, r;
          }
          e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
        },
        "6lFg": function lFg(e) {
          function t(r) {
            return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
        },
        "8nn0": function nn0(e, t, r) {
          var n = r("VDhh")();
          e.exports = n;
          try {
            regeneratorRuntime = n;
          } catch (e) {
            "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
          }
        },
        BxeL: function BxeL(e) {
          "use strict";

          e.exports = JSON.parse('{"accType":"","socialEmailId":"","fName":"","lName":"","socialId":"115635989479271832898","authToken":"","query":[[{"name":"extendedUser","keys":["primaryEmailId","accountId","profileType","corporateData","personalDetails","createdAt"]}],[{"name":"extendedUser"},{"name":"contactDetails","keys":["contactId","type","category","name","info","additionalDetails"],"filters":[{"name":"status","value":"Active"}]}],[{"name":"personalDetails","keys":["name","gender","childNCount","maritalStatus","anniversaryDate","dateOfBirth"]}],[{"name":"extendedUser"},{"name":"loginInfoList","keys":["loginId","verified","status","loginType","countryCode"],"filters":[{"name":"verified","value":true},{"name":"status","value":"ACTIVE"}]}],[{"name":"extendedUser"},{"name":"userImages","keys":["id","fileName","filePath","status"],"filters":[{"name":"status","value":"Active"}]}]]}');
        }
      },
      i = {};
    function a(e) {
      var t = i[e];
      if (void 0 !== t) return t.exports;
      var r = i[e] = {
        exports: {}
      };
      return o[e](r, r.exports, a), r.exports;
    }
    a.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return a.d(t, {
        a: t
      }), t;
    }, a.d = function (e, t) {
      for (var r in t) a.o(t, r) && !a.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, a.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    };
    var s = {};
    return function () {
      "use strict";

      a.d(s, {
        default: function _default() {
          return Hr;
        }
      });
      var e = "awefewfuihewfhewfuhiebc",
        t = "limitedConsent",
        r = "fullConsent",
        n = "enct-",
        o = {
          ES: "essential",
          N_ES: "nonEssential"
        };
      var i = "undefined" != typeof window;
      a("8nn0");
      var u = !1;
      function l(e) {
        return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, l(e);
      }
      function c(e) {
        var t = function (e, t) {
          if ("object" !== l(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== l(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" === l(t) ? t : String(t);
      }
      function f(e, t, r) {
        return (t = c(t)) in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      var d = "GI",
        p = "IGO",
        h = "HDFC_SB",
        y = "AFFCGOBIZMMTAIX",
        m = "AFFCGOBIZMMTFLTEXP",
        g = "AFFCGOBIZGIFLTEXP",
        v = "AFFTMFXGIFOREXEXP",
        E = "AFFTMFXMMTFOREXEXP",
        S = (f(f(f({}, d, {
          colors: {
            base: {
              primary: "#016eff"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],
            family: "'Quicksand', sans-serif",
            familyHeading: "'Quicksand', sans-serif"
          }
        }), p, {
          colors: {
            base: {
              primary: "#00228E"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #00228E, #00228E)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
            family: "'Lato'",
            familyHeading: "'ITC Bauhaus'"
          }
        }), y, {
          colors: {
            base: {
              primary: "#FF6423"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
            family: "'Lato'",
            familyHeading: "'ITC Bauhaus'"
          }
        }), f(f({}, d, {
          ACCOUNTS_TERMS_CONDITION: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html",
          ACCOUNTS_PRIVACY_URL: "https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",
          TERMS_OF_SERVICE: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"
        }), p, {
          ACCOUNTS_TERMS_CONDITION: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",
          ACCOUNTS_PRIVACY_URL: "https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",
          TERMS_OF_SERVICE: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"
        }), function (e) {
          var t,
            r = e || "";
          i && (r = (null === (t = window) || void 0 === t || null === (t = t.location) || void 0 === t ? void 0 : t.hostname) || "");
          var n = "";
          return r && (-1 !== r.indexOf("giholidays") ? n = d : -1 !== r.indexOf("6eholidays") ? n = p : -1 !== r.indexOf("hdfcsmartbuyholidays") ? n = h : -1 !== r.indexOf("airindiaexpressholidays") ? n = y : -1 !== r.indexOf("flightsexpert.goibibo") ? n = g : -1 !== r.indexOf("flightsexpert.makemytrip") ? n = m : -1 !== r.indexOf("forexexpert.makemytrip") ? n = E : -1 !== r.indexOf("forexexpert.goibibo") && (n = v)), n;
        }),
        T = function T(e) {
          try {
            return JSON.stringify(e);
          } catch (e) {
            return null;
          }
        },
        _ = function _(e) {
          try {
            return JSON.parse(e);
          } catch (e) {
            return null;
          }
        },
        L = {},
        O = function O(e, t, r, n) {
          var a,
            s,
            u = r,
            l = n,
            c = (null == L ? void 0 : L[e]) || {};
          i && (u = void 0 === r ? (null === (a = c[t]) || void 0 === a ? void 0 : a.type) || o.N_ES : r, l = void 0 === n ? (null === (s = c[t]) || void 0 === s ? void 0 : s.isPiiData) || !1 : n);
          return {
            essential: u = u === o.ES,
            piiData: l
          };
        },
        A = function A(e) {
          return new RegExp("(?:^|;\\s*)".concat(e, "\\s*=\\s*([^;]*)"));
        },
        I = function I(e) {
          var t,
            r,
            n,
            o = (t = e, (n = S(r).toLowerCase()) ? "".concat(t, "-").concat(n) : t),
            i = A(o).exec(document.cookie);
          return null !== i ? decodeURIComponent(i[1]) : null;
        },
        w = function w() {
          return function (e) {
            return !e || "IS" !== e && "11" !== e ? r : t;
          }(I("GDPR_C"));
        },
        x = function x() {
          var e, r, n;
          return "1" !== I("isGdprRegion") || (e = I("myBusinessSubscription"), r = I("mmt-auth"), n = null == r ? void 0 : r.charAt(r.length - 1), !!(e && "b2b" === e || "C" === n) || w() !== t);
        },
        b = "cookieList",
        P = "sessionList";
      function D(e, t) {
        try {
          var r = "",
            n = 0;
          if (!t) throw new Error("Key is empty");
          for (var o = 0; o < e.length; o += 1) {
            var i = e.charCodeAt(o) ^ t.charCodeAt(n);
            r += String.fromCharCode(i), n = (n + 1) % t.length;
          }
          return r;
        } catch (e) {
          return console.error("An error occurred during encryption:", e), null;
        }
      }
      function R(e, t) {
        try {
          var r = "",
            n = 0;
          if (!t) throw new Error("Key is empty");
          for (var o = 0; o < e.length; o += 1) {
            var i = e.charCodeAt(o) ^ t.charCodeAt(n);
            r += String.fromCharCode(i), n = (n + 1) % t.length;
          }
          return r;
        } catch (e) {
          return console.error("An error occurred during the decryption process:", e), null;
        }
      }
      var U = function U(e) {
          return new TypeError("Valid key & value is required for @MMT-UI/storages$$/client/cookies ".concat(e));
        },
        N = function N(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            o = arguments.length > 2 ? arguments[2] : void 0;
          try {
            var a;
            if (!i) return null;
            if (!t) throw U("get");
            var s,
              u = (r || {}).isPiiData,
              l = (r || {}).shouldParseJson,
              c = O(b, t, o, u);
            if (s = c.essential, u = c.piiData, !s && !x()) return null;
            var f = A(t).exec(document.cookie),
              d = null !== f ? decodeURIComponent(f[1]) : null;
            if (u && null !== (a = d) && void 0 !== a && a.includes(n)) {
              var p = new RegExp("^".concat(n));
              d = R(d = d.replace(p, ""), e);
            }
            return l && (d = _(d)), d;
          } catch (e) {
            return null;
          }
        },
        C = function C(t, r, o, a) {
          try {
            if (!i) return !1;
            if (!t || void 0 === r) throw U("set");
            var s,
              c = o || {},
              f = c.expiresVal,
              d = c.maxAge,
              p = c.path,
              h = c.domain,
              y = c.secure,
              m = c.sameSite,
              g = c.shouldStringifyJson,
              v = c.partitioned,
              E = (o || {}).isPiiData,
              S = O(b, t, a, E);
            if (s = S.essential, E = S.piiData, !s && !x()) return !1;
            var _ = g ? T(r) : r;
            if (_ && E) {
              var L = D(_, e);
              if (!L) return !1;
              _ = "".concat(n).concat(L);
            }
            var A = function (e, t) {
                var r = e ? "; max-age=".concat(e) : "",
                  n = "";
                if (t) switch (l(t)) {
                  case "string":
                    n = "; expires=".concat(new Date(t).toUTCString());
                    break;
                  case "number":
                    var o = new Date();
                    o.setSeconds(t), n = "; expires=".concat(o.toUTCString());
                    break;
                  case "object":
                    t instanceof Date && (n = "; expires=".concat(t.toUTCString()));
                }
                return {
                  sMaxAge: r,
                  sExpiry: n
                };
              }(d, f),
              I = A.sMaxAge,
              w = A.sExpiry,
              P = v || u ? "; samesite=none; secure; partitioned" : "";
            P || (P = y ? m ? "; samesite=".concat(m, "; secure") : "; secure" : m ? "; samesite=".concat(m) : "");
            var R = "".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(_)),
              N = "".concat(I).concat(w).concat(p ? "; path=".concat(p) : ""),
              C = "".concat(h ? "; domain=".concat(h) : "").concat(P);
            return document.cookie = "".concat(R).concat(N).concat(C), !0;
          } catch (e) {
            return !1;
          }
        },
        F = function F(e) {
          return new TypeError("Valid key & value is required for sessionStorage ".concat(e));
        },
        M = function M(t, r, o, a) {
          try {
            if (!i || !sessionStorage) return !1;
            if (!t || void 0 === r) throw F("get");
            var s,
              u = (o || {}).isPiiData,
              l = (o || {}).shouldStringifyJson,
              c = O(P, t, a, u);
            if (s = c.essential, u = c.piiData, !s && !x()) return !1;
            var f = l ? T(r) : r;
            if (f && u) {
              var d = D(f, e);
              if (!d) return !1;
              f = "".concat(n).concat(d);
            }
            return sessionStorage.setItem(t, f), !0;
          } catch (e) {
            return !1;
          }
        },
        G = function G() {
          return N("userCurrency", void 0, o.ES);
        },
        k = "undefined" != typeof window;
      var j,
        W,
        B,
        V,
        H,
        Y,
        q,
        z,
        J = {
          IN: "IN",
          US: "US",
          AE: "AE",
          KW: "KW",
          SA: "SA",
          OM: "OM",
          ROW: "ROW"
        },
        K = ((j = {})[J.IN] = "IN", j[J.AE] = "AE", j[J.US] = "US", (W = {})[J.IN] = "IN", W[J.AE] = "UAE", W[J.US] = "USA", (B = {})[J.IN] = "India", B[J.AE] = "UAE", B[J.US] = "US", B),
        Z = ((V = {})[J.IN] = "India", V[J.AE] = "UAE", V[J.US] = "US", V[J.ROW] = "Rest of the World", V),
        Q = (k && (i ? null === (q = window.localeSettings) || void 0 === q || q.multicurrencyEnabled : null == Y || null === (z = Y.parameters) || void 0 === z || null === (z = z.localeSettings) || void 0 === z || z.multicurrencyEnabled), "eng"),
        X = ((H = {})[J.IN] = {
          setAltLangCookies: ["hin", "tam"]
        }, Object.assign({
          "makemytrip.us": {
            siteDomain: "US",
            authorization: "FIxy0LJVle9UIg8"
          },
          "makemytrip.ae": {
            siteDomain: "UAE",
            authorization: "6gA2Wuz9cQEwqJq"
          },
          "makemytrip.om": {
            siteDomain: "OM",
            authorization: "6gA2Wuz9cQEwqJq"
          },
          "makemytrip.sa": {
            siteDomain: "SA",
            authorization: "6gA2Wuz9cQEwqJq"
          },
          "makemytrip.kw": {
            siteDomain: "KW",
            authorization: "6gA2Wuz9cQEwqJq"
          }
        }, {})),
        $ = {
          IN: "in",
          AE: "ae",
          US: "us",
          KW: "kw",
          SA: "sa",
          OM: "om"
        },
        ee = {
          IN: "inr",
          US: "usd",
          AE: "aed",
          KW: "kwd",
          SA: "sar",
          OM: "omr"
        },
        te = Q,
        re = function re() {
          var e = "www.makemytrip.com";
          k && (e = window.location.hostname);
          var t = (e = e.replace("www.", "").replace(":8000")).split(".");
          return t.splice(t.length - 2, t.length).join(".");
        },
        ne = {},
        oe = function oe() {
          if (!k) throw new Error("getCountry method is valid only for client read from store.geography.countryCode");
          var e = ne.countryCode;
          return e ? J[e] : J.IN;
        },
        ie = function ie() {
          return ee[oe()];
        },
        ae = function ae() {
          return $[oe()];
        },
        se = {},
        ue = function ue() {
          if (!k) throw new Error("getLanguage method is valid only for client read from store instead (isInternationsal selector)");
          return se && se.languageCode || te;
        };
      var le = {
        userServiceUrl: "//mapi." + re(),
        userServiceUrlServer: "//mapi.mmt.mmt",
        cosmosApiUrl: "//mapi." + re(),
        ccbUrl: "//corpcb." + re(),
        myBiz: "//mapi." + re(),
        deviceFingerprintingV2Url: "//www.makemytrip.com"
      };
      var ce = a("kpo/"),
        fe = a.n(ce),
        de = "PERSONAL",
        pe = "ADMIN",
        he = "lang",
        ye = "userInfo",
        me = "auths",
        ge = "x-gommt-client-id",
        ve = null;
      function Ee() {
        if (!k) throw new Error("this method is valid only for client, use Connect function");
        return ve;
      }
      var Se = null,
        Te = function Te(e) {
          if (e) return e;
          if (k) {
            var t = Ee();
            return function (e) {
              return fe()(e, "common.affiliate");
            }(t && t.getState()) || "";
          }
          return "";
        },
        _e = function _e() {
          var e,
            t,
            r,
            n = null == Se ? void 0 : Se.getState();
          return null != n && null != (e = n.geography) && e.renderConfigurations ? (null == n || null == (t = n.geography) ? void 0 : t.renderConfigurations) || {} : k && (null == (r = window) || null == (r = r.header) ? void 0 : r.renderConfigurations) || {};
        },
        Le = function Le(e, t) {
          var r = Te(t).toLowerCase(),
            n = e;
          return r && (n = e + "-" + r), n;
        },
        Oe = function Oe(e) {
          return k ? Te(e) ? "." + window.location.hostname : "." + re() : "";
        };
      var Ae = function Ae() {
          var e = new Date().getTime();
          return "undefined" != typeof performance && "function" == typeof performance.now && (e += performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
            var r = (e + 16 * Math.random()) % 16 | 0;
            return e = Math.floor(e / 16), ("x" === t ? r : 3 & r | 8).toString(16);
          });
        },
        Ie = function Ie() {
          var e = new Date(),
            t = e.getTime();
          return t += 305856e5, e.setTime(t), e;
        },
        we = function we(e) {
          if (!N(Le("dvid"), void 0, o.ES) && e) {
            var t = Ie();
            C(Le("dvid"), e, {
              expiresVal: t,
              path: "/",
              domain: Oe()
            }, o.ES);
          }
        },
        xe = function xe() {
          var e = N(Le("dvid"), void 0, o.ES) || Ae();
          return we(e), e;
        },
        be = "userServiceUrl",
        Pe = a("dqD6"),
        De = a.n(Pe)().create(),
        Re = function Re(e) {
          var t = e;
          t["Content-Type"] = "application/json", t.os && null != t.os || (t.os = "desktop"), t.vid = xe(), t.tid = xe(), t.deviceId = xe(), t.Authorization = t.Authorization || (X[re()] || "").authorization || "h4nhc9jcgpAGIjp", t.Accept = "application/json", t["visitor-id"] = xe(), t.region = ae(), t.currency = ie(), t["user-currency"] = G(), null != t && t.useDefaultLang ? t.language = te : t.language = N(Le(he), void 0, o.ES) || ue(), N(Le("mmt-auth"), void 0, o.ES) ? t["mmt-auth"] = N(Le("mmt-auth"), void 0, o.ES) : (t["mmt-auth"] = null, delete t["mmt-auth"]);
        },
        Ue = function Ue(e, t, r, n, i, s) {
          var u,
            l = i;
          if (!k && a.g.blockAPICalls) return {};
          var c = "" + (s ? le[t] : le.localURl) + r,
            f = {
              baseUrlKey: t,
              url: r,
              data: n,
              method: e
            };
          null != l && l || (l = {}), l[ge] && "HDFC_SB" !== l[ge] || delete l[ge];
          var d = {
            headers: l
          };
          return null != (u = l) && u.timeout && (d.timeout = l.timeout, delete l.timeout), k && (Re(l), d = function (e, t) {
            var r = e,
              n = {};
            return null != r && r.preventLocale || (n = {
              region: ae(),
              currency: ie(),
              "user-currency": G()
            }, null != r && r.useDefaultLang ? n.language = te : n.language = N(Le(he), void 0, o.ES) || ue()), null == r || delete r.useDefaultLang, null == r || delete r.preventLocale, t === be ? {
              headers: r,
              withCredentials: !0,
              params: n
            } : {
              headers: r,
              params: n
            };
          }(l, t)), "POST" === e || "DELETE" === e && !1 === s || "GET" === e && !1 === s ? De.post(c, s ? n : f, d) : "GET" === e ? De.get(c, d) : "DELETE" === e ? De.delete(c, d) : "PUT" === e ? De.put(c, s ? n : f, d) : null;
        };
      var Ne = function Ne(e, t, r, n, o) {
        return Ue("POST", e, t, r, o, n);
      };
      var Ce = {
          type: "SESSION_ID",
          query: [[{
            name: "extendedUser",
            keys: ["primaryEmailId", "uuid", "accountId", "profileType", "contactDetails", "corporateData", "affiliateId"]
          }], [{
            name: "extendedUser"
          }, {
            name: "userImages",
            keys: ["fileName", "filePath", "id", "status"],
            filters: [{
              name: "status",
              value: "ACTIVE"
            }]
          }], [{
            name: "extendedUser"
          }, {
            name: "contactDetails",
            keys: ["contactId", "type", "category", "name", "info", "additionalDetails", "status"],
            filters: [{
              name: "status",
              value: "ACTIVE"
            }]
          }], [{
            name: "personalDetails",
            keys: ["name", "gender", "childNCount", "maritalStatus", "anniversaryDate", "dateOfBirth", "nationality"]
          }], [{
            name: "extendedUser"
          }, {
            name: "loginInfoList",
            keys: ["loginId", "verified", "status", "loginType", "countryCode"],
            filters: [{
              name: "verified",
              value: !0
            }, {
              name: "status",
              value: "ACTIVE"
            }]
          }]]
        },
        Fe = a("tMQ+"),
        Me = a.n(Fe),
        Ge = a("rCRV"),
        ke = "SHOW_HEADER_LOADER",
        je = "HIDE_HEADER_LOADER",
        We = "DO_LOGIN",
        Be = "CLEAR_LOGIN_ERROR",
        Ve = "CLEAR_WALLET",
        He = "CHECK_USER_REGISTRATION",
        Ye = "FORGOT_PASSWORD",
        qe = "DO_SIGNUP",
        ze = "RESET_SIGNUP",
        Je = "DO_SOCIAL_LOGIN",
        Ke = "SEND_OTP",
        Ze = "SIGNUP_OTP",
        Qe = "VERIFY_SIGNUP_OTP",
        Xe = "VERIFY_OTP_SIGNUP_UPDATE_DETAILS",
        $e = "VERIFY_OTP",
        et = "RESET_OTP_VERIFY_STATE",
        tt = "DO_LOGOUT",
        rt = "GET_USER_DETAILS",
        nt = "GET_WALLET_DETAILS",
        ot = "GET_CRED_DETAILS",
        it = "SAVE_LOGIN_USER_DETAILS",
        at = "FORGOT_PASSWORD_OTP",
        st = "FORGOT_PASSWORD_UPDATE",
        ut = "RESET_FORGOT_PASSWORD_STATE",
        lt = "UPDATE_USER_DETAILS",
        ct = "SEND_LOGIN_OTP",
        ft = "RESEND_LOGIN_OTP",
        dt = "RESET_SEND_LOGIN_OTP",
        pt = "RESET_RESEND_LOGIN_OTP",
        ht = "SET_USER_NAME",
        yt = "RESET_USER_NAME",
        mt = "RESET_LOGIN",
        gt = "LOGIN_FROM_AUTHS",
        vt = "SET_ACTIVE_MODAL",
        Et = "RESET_SIGNUP_UPDATE_USER_DETAILS_STATE",
        St = "DOING_AFTER_LOGIN_FORMALITIES",
        Tt = "UPDATE_USER_STATE",
        _t = "UPDATE_USER_INFO",
        Lt = "SET_ACCOUNT_TYPE",
        Ot = "SET_DISABLE_TYPE",
        At = "SET_SHOW_TIMED_OUT_POPUP",
        It = "SET_MODAL_ACC_TYPE",
        wt = "GET_PENDING_REQUESTS",
        xt = "RESET_LOGIN_ERROR",
        bt = "CLEAR_ERROR_MESSAGE",
        Pt = "SET_SHOW_OTP_ERROR_POPUP",
        Dt = "RESET_TEMP_AUTHS",
        Rt = "IS_SWITCH_ACCOUNT_AVAILABLE",
        Ut = "CLEAR_WALLET_DETAILS",
        Nt = "HANDLE_AUTH_ON_ROUTE",
        Ct = "LINK_PERSONAL_TO_MY_BIZ",
        Ft = "SET_ACTIVE_MENU_ITEM",
        Mt = "REFRESH_USER_DETAILS",
        Gt = "UPDATE_LOGIN",
        kt = "SET_AFTER_LOGIN_URL",
        jt = "SET_LOGIN_SCREEN_TYPE",
        Wt = "CLEAR_IS_USER_REG",
        Bt = "SET_LINK_MOBILE",
        Vt = "RESET_LINK_MOBILE",
        Ht = "SET_OTP_DISPLAY_MESSAGE",
        Yt = "SET_OTP_DATA",
        qt = "RESET_OTP_DISPLAY_MESSAGE",
        zt = "SET_OTP_DISPLAY_TITLE",
        Jt = "RESET_OTP_DISPLAY_TITLE",
        Kt = "SET_COUNTRY",
        Zt = "RESET_COUNTRY",
        Qt = "SETUP_PAYMENTS",
        Xt = "CHECK_USER_REGISTRATION_CLEAR_ERROR",
        $t = "LOGIN_AFTER_MYBIZ_SIGNUP",
        er = "PREFILL_API",
        tr = "SET_PREFILL_DATA",
        rr = "LOGIN_POPUP_STATE",
        nr = "GET_LOYALTY_INFO",
        or = "SET_LANGUAGE_DATA",
        ir = "SET_LANGUAGE",
        ar = "SET_COUNTRY_CODE",
        sr = "SET_LOCALE_SETTINGS",
        ur = "SET_RENDER_CONFIGURATION",
        lr = "SET_LANGUAGE_LIST_MAP",
        cr = "HANDLE_SWITCH_ACCOUNT_NOT_AVAILABLE",
        fr = "SET_BIZ_AUTH_AS_ALTERNATE",
        dr = "SET_LOGIN_AUTHS_WITHOUT_BIZ_SWITCH",
        pr = "SET_AFFILIATE",
        hr = "SET_PREV_MODAL_STATE",
        yr = "CONFIRM_MYBIZ_PERSONAL_LOGIN",
        mr = "SET_REDIRECT_MYBIZ_USERNAME",
        gr = "SET_USER_PROFILE_DATA",
        vr = "SET_USER_AUTHS_DATA",
        Er = "SIGNUP_DETAILS",
        Sr = "SET_USERTYPE_CODE",
        Tr = function Tr(e) {
          return e + "_SUCCESS";
        },
        _r = function _r(e) {
          return e + "_FAILED";
        };
      function Lr(e) {
        return function (t) {
          return {
            type: e,
            payload: t
          };
        };
      }
      var Or = {
        insertMountProps: Lr("INSERT_MOUNT_PROPS"),
        showLoader: Lr(ke),
        hideLoader: Lr(je),
        getUserDetails: Lr(rt),
        getUserDetailsSuccess: Lr(Tr(rt)),
        getUserDetailsFailure: Lr(_r(rt)),
        getWalletDetails: Lr(nt),
        getWalletDetailsSuccess: Lr(Tr(nt)),
        getWalletDetailsFailure: Lr(_r(nt)),
        getCredDetails: Lr(ot),
        getCredDetailsSuccess: Lr(Tr(ot)),
        getCredDetailsFailure: Lr(_r(ot)),
        updateUserDetails: Lr(lt),
        updateUserDetailsSuccess: Lr(Tr(lt)),
        updateUserDetailsFailed: Lr(_r(lt)),
        saveUserDetails: Lr(it),
        checkUserRegistration: Lr(He),
        checkUserRegistrationSuccess: Lr(Tr(He)),
        checkUserRegistrationFailed: Lr(_r(He)),
        doLogin: Lr(We),
        doLoginSuccess: Lr(Tr(We)),
        doLoginFailure: Lr(_r(We)),
        clearLoginError: Lr(Be),
        clearWallet: Lr(Ve),
        doSignUp: Lr(qe),
        doSignUpSuccess: Lr(Tr(qe)),
        doSignUpFailure: Lr(_r(qe)),
        resetSignUp: Lr(ze),
        doSocialLogin: Lr(Je),
        doSocialLoginSuccess: Lr(Tr(Je)),
        doSocialLoginFailure: Lr(_r(Je)),
        forgotPassword: Lr(Ye),
        forgotPasswordSuccess: Lr(Tr(Ye)),
        forgotPasswordFailure: Lr(_r(Ye)),
        forgotPasswordOTP: Lr(at),
        forgotPasswordOTPSuccess: Lr(Tr(at)),
        forgotPasswordOTPFailure: Lr(_r(at)),
        forgotPasswordUpdate: Lr(st),
        forgotPasswordUpdateSuccess: Lr(Tr(st)),
        forgotPasswordUpdateFailure: Lr(_r(st)),
        resetForgotPasswordState: Lr(ut),
        sendOTP: Lr(Ke),
        sendOTPSuccess: Lr(Tr(Ke)),
        sendOTPFailure: Lr(_r(Ke)),
        signUpOTP: Lr(Ze),
        signUpOTPSuccess: Lr(Tr(Ze)),
        signUpOTPFailure: Lr(_r(Ze)),
        verifySignUpOTP: Lr(Qe),
        verifySignUpOTPSuccess: Lr(Tr(Qe)),
        verifySignUpOTPFailure: Lr(_r(Qe)),
        verifyOTP: Lr($e),
        verifyOTPSuccess: Lr(Tr($e)),
        verifyOTPFailure: Lr(_r($e)),
        resetOtpVerifyState: Lr(et),
        doLogout: Lr(tt),
        sendLoginOtp: Lr(ct),
        sendLoginOtpSuccess: Lr(Tr(ct)),
        sendLoginOtpFailure: Lr(_r(ct)),
        resendLoginOtp: Lr(ft),
        resendLoginOtpSuccess: Lr(Tr(ft)),
        resendLoginOtpFailure: Lr(_r(ft)),
        resetSendLoginOtp: Lr(dt),
        resetResendLoginOtp: Lr(pt),
        setUserName: Lr(ht),
        setUserTypeCode: Lr(Sr),
        resetUserName: Lr(yt),
        resetLogin: Lr(mt),
        loginFromAuths: Lr(gt),
        setModalTo: Lr(vt),
        setModalAccTypeTo: Lr(It),
        verifyOtpSignUpUpdateDetails: Lr(Xe),
        resetSignUpUpdateUserDetailsState: Lr(Et),
        setDoingLoginFormalities: Lr(St),
        updateUserState: Lr(Tt),
        updateUserInfo: Lr(_t),
        setAccountType: Lr(Lt),
        setDisableType: Lr(Ot),
        setShowTimedOutPopup: Lr(At),
        getPendingRequests: Lr(wt),
        getPendingRequestsSuccess: Lr(Tr(wt)),
        getPendingRequestsFaliure: Lr(_r(wt)),
        resetLoginError: Lr(xt),
        clearSignupErrorMessage: Lr(bt),
        setShowOtpErrorPopup: Lr(Pt),
        resetTempAuths: Lr(Dt),
        setIsSwitchAccountAvailable: Lr(Rt),
        clearWalletDetails: Lr(Ut),
        handleAuthsOnRoute: Lr(Nt),
        linkPersonalToMyBiz: Lr(Ct),
        setActiveMenuItem: Lr(Ft),
        refreshUserDetails: Lr(Mt),
        updateLogin: Lr(Gt),
        setAfterLoginUrl: Lr(kt),
        clearIsUserRegistered: Lr(Wt),
        setLoginScreenType: Lr(jt),
        setLinkMobile: Lr(Bt),
        resetLinkMobile: Lr(Vt),
        setOtpDisplayMessage: Lr(Ht),
        setOtpData: Lr(Yt),
        resetOtpDisplayMessage: Lr(qt),
        setOtpDisplayTitle: Lr(zt),
        resetOtpDisplayTitle: Lr(Jt),
        setCountry: Lr(Kt),
        resetCountry: Lr(Zt),
        setupPayments: Lr(Qt),
        clearCheckUserRegistrationError: Lr(Xt),
        loginAfterMyBizSignup: Lr($t),
        prefillApiCall: Lr(er),
        prefillApiCallSuccess: Lr(Tr(er)),
        prefillApiCallFailure: Lr(_r(er)),
        setPrefillData: Lr(tr),
        setLoginPopupState: Lr(rr),
        getLoyaltyInfo: Lr(nr),
        getLoyaltyInfoSuccess: Lr(Tr(nr)),
        getLoyaltyInfoFailure: Lr(_r(nr)),
        setLanguageData: Lr(or),
        setLanguageDataSuccess: Lr(Tr(or)),
        setLanguage: Lr(ir),
        setCountryCode: Lr(ar),
        setLocaleSettings: Lr(sr),
        setRenderConfiguration: Lr(ur),
        setLanguageListMap: Lr(lr),
        handleSwitchAccountNotAvailable: Lr(cr),
        setBizAuthAsAlternate: Lr(fr),
        setLoginAuthsWithoutBizSwitch: Lr(dr),
        setConfirmMybizPersonalLogin: Lr(yr),
        setAffiliate: Lr(pr),
        setPrevModalState: Lr(hr),
        setRedirectMybizUsername: Lr(mr),
        setUserProfileDetails: Lr(gr),
        setUserAuths: Lr(vr),
        setSignupDetails: Lr(Er)
      };
      var Ar = function Ar(e) {
        return e && e.geography && e.geography.langData;
      };
      var Ir = function Ir(e) {
        var t = e.text,
          r = e.trimLength,
          n = void 0 === r ? 5 : r;
        return t && "string" == typeof t ? Me().createElement("div", {
          className: "customTooltipHeader"
        }, t.substring(0, n) + "...", Me().createElement("span", {
          className: "customTooltipTextHeader"
        }, t)) : null;
      };
      var wr = function wr(e) {
          if (!k && !e.data) throw new Error(e.id + " language data is mendatory at server");
          var t = e.id,
            r = e.defaultMessage,
            n = void 0 === r ? "" : r,
            o = e.values,
            i = void 0 === o ? {} : o;
          if (e.useDefaultText) return n;
          var a = e.data;
          if (!a) {
            var s = Ee(),
              u = s && s.getState();
            a = Ar(u) || {};
          }
          var l = function (e, t) {
            var r = e,
              n = Object.keys(t);
            return n.length && n.forEach(function (e) {
              r = r.replace("{" + e + "}", t[e]);
            }), r;
          }(a[t] || n, i);
          return l;
        },
        xr = function xr(e) {
          return {
            __html: wr({
              useDefaultText: null == e ? void 0 : e.useDefaultText,
              id: e.id,
              values: e.values,
              defaultMessage: e.defaultMessage,
              data: e.data
            })
          };
        };
      function br(e) {
        return {
          data: Ar(e)
        };
      }
      (0, Ge.connect)(br, Or)(function (e) {
        var t = {
          key: Date(),
          dangerouslySetInnerHTML: xr(e)
        };
        return "function" == typeof e.children ? e.children(t) : Me().cloneElement(e.children, t);
      });
      (0, Ge.connect)(br, Or)(function (e) {
        var t = e.shouldTrimify,
          r = e.trimLength,
          n = wr(e);
        return t ? Me().createElement(Ir, {
          trimLength: r,
          text: n
        }) : n;
      });
      var Pr = function Pr(e) {
          var t,
            r = JSON.parse(e.corporateData),
            n = fe()(r, "employee.employeeStatus"),
            o = function (e) {
              var t = !1;
              if (e && e.employee) {
                var r = e.employee,
                  n = r.provisionAdmin,
                  o = r.roles,
                  i = !1;
                o && o.indexOf(pe) > -1 && (i = !0), t = n && !i;
              }
              return t;
            }(r);
          n ? ("DISABLED" === n && (t = {
            isEmployee: !0,
            isActive: !1,
            message: r.employee.displayMessage
          }), t = {
            isEmployee: !0,
            isActive: !0,
            employeeInfo: r,
            isProvAdmin: o
          }) : t = {
            isEmployee: !1
          };
          var i,
            a,
            s,
            u = (i = t, a = "", (s = fe()(i, "employeeInfo.employee.roles")) && s.indexOf(pe) > -1 ? a = "admin" : s && s.length > 0 && (a = "nonadmin"), a);
          return Object.assign({}, t, {
            corporateRole: u,
            blockLobs: fe()(r, "employee.blockLobs", [])
          });
        },
        Dr = function Dr(e) {
          var t,
            r,
            n,
            o,
            i,
            a,
            s = e.extendedUser,
            u = s.personalDetails,
            l = Pr(s),
            c = JSON.parse(s.corporateData),
            f = fe()(c, "employee.showMsmeWelcomePopup"),
            d = null == c || null == (t = c.employee) ? void 0 : t.showSubscriptionPopup,
            p = l.blockLobs,
            h = null == p || null == (r = p.filter(function (e) {
              var t;
              return "1" === (null == e || null == (t = e.split("|")) ? void 0 : t[1]);
            })) ? void 0 : r.map(function (e) {
              var t;
              return null == e || null == (t = e.split("|")) ? void 0 : t[0];
            }),
            y = null == p || null == (n = p.filter(function (e) {
              var t;
              return "0" === (null == e || null == (t = e.split("|")) ? void 0 : t[1]);
            })) ? void 0 : n.map(function (e) {
              var t;
              return null == e || null == (t = e.split("|")) ? void 0 : t[0];
            }),
            m = {},
            g = (_e() || {}).verifiedUserMobileNumber;
          if (!1 === l.isEmployee || l.isEmployee && l.isActive) {
            var v;
            m.email = s.primaryEmailId, m.uuid = s.uuid, l.isEmployee && (m.employeeInfo = l.employeeInfo, m.isProvAdmin = l.isProvAdmin, m.corporateRole = l.corporateRole, m.showMsmeWelcomePopup = f, m.showSubscriptionPopup = d), m.firstName = u && u.name && u.name.firstName ? u.name.firstName : "", m.lastName = u && u.name && u.name.lastName ? u.name.lastName : "";
            var E = (i = s.contactDetails, (a = s.loginInfoList) && function (e) {
              return !!e && e.filter(function (e) {
                return e && "MOBILE" === e.loginType;
              }).length > 0;
            }(a) ? a.filter(function (e) {
              return e && "MOBILE" === (null == e ? void 0 : e.loginType);
            }).map(function (e) {
              var t,
                r,
                n = e.countryCode,
                o = (e || {}).loginId;
              return null != (t = o) && t.startsWith(n) && (o = null == (r = o) ? void 0 : r.substring(null == n ? void 0 : n.toString().length)), {
                countryCode: n,
                mobileNumber: o,
                verified: !0
              };
            })[0] || {} : i && i.filter(function (e) {
              return e && "MOBILE" === e.type;
            }).map(function (e) {
              var t,
                r,
                n = JSON.parse(null == e ? void 0 : e.additionalDetails).CountryCode,
                o = (e || {}).info;
              return null != (t = o) && t.startsWith(n) && (o = null == (r = o) ? void 0 : r.substring(null == n ? void 0 : n.toString().length)), {
                countryCode: n,
                mobileNumber: o,
                verified: !1
              };
            })[0] || {});
            return m.mobileNumber = E.mobileNumber ? E.mobileNumber : "", m.countryCode = E.countryCode ? E.countryCode.toString() : "", m.verified = !!E.verified || g && !!E.mobileNumber, m.profileType = s.profileType, m.actualProfileType = s.actualProfileType, m.blockLobs = h, m.hiddenLobs = y, m.corporateData = s.corporateData, m.affiliateId = s.affiliateId, m.createdAt = s.createdAt, m.nationality = null == s || null == (v = s.personalDetails) ? void 0 : v.nationality, m.personalDetails = s.personalDetails, m.userImages = (o = s.userImages) && o.length && "" + o[0].filePath + o[0].fileName + "?ver=" + o[0].id || "", m;
          }
          return l.isEmployee && !l.isActive && (m.error = l.message), m;
        },
        Rr = function Rr(e) {
          return "BUSINESS" !== e && "AGENT" !== e && e !== de;
        };
      var Ur = function Ur(e) {
          var t;
          return (null == e || null == (t = e.data) || null == (t = t.data) ? void 0 : t.profileLoginResponse) || [];
        },
        Nr = function Nr(e, t) {
          var r;
          return null == e || null == (r = e.filter(function (e) {
            return (null == e ? void 0 : e.authToken) === t;
          })[0]) ? void 0 : r.userDetails;
        },
        Cr = function Cr(e, t, r) {
          return e ? (function (e) {
            var t = e.extendedUser,
              r = t.profileType;
            Rr(r) && (t.actualProfileType = r, t.profileType = de);
          }(e), {
            userInfo: Dr(e)
          }) : {
            userInfo: null
          };
        },
        Fr = function Fr(e, t, r) {
          return '{"ipAddress":"ipAddress","imie":"imie","appVersion":"appVersion","deviceId":"' + e + '","os":"PWA","osVersion":"osVersion","profileType":"' + r + '","timeZone":"timeZone","type":"mmt-auth","value":"' + t + '","cookie":"' + t + '"}';
        };
      function Mr() {
        Mr = function Mr() {
          return t;
        };
        var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
            e[t] = r.value;
          },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          s = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";
        function l(e, t, r) {
          return Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), e[t];
        }
        try {
          l({}, "");
        } catch (e) {
          l = function l(e, t, r) {
            return e[t] = r;
          };
        }
        function c(e, t, r, n) {
          var i = t && t.prototype instanceof g ? t : g,
            a = Object.create(i.prototype),
            s = new P(n || []);
          return o(a, "_invoke", {
            value: I(e, r, s)
          }), a;
        }
        function f(e, t, r) {
          try {
            return {
              type: "normal",
              arg: e.call(t, r)
            };
          } catch (e) {
            return {
              type: "throw",
              arg: e
            };
          }
        }
        t.wrap = c;
        var d = "suspendedStart",
          p = "suspendedYield",
          h = "executing",
          y = "completed",
          m = {};
        function g() {}
        function v() {}
        function E() {}
        var S = {};
        l(S, a, function () {
          return this;
        });
        var T = Object.getPrototypeOf,
          _ = T && T(T(D([])));
        _ && _ !== r && n.call(_, a) && (S = _);
        var L = E.prototype = g.prototype = Object.create(S);
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            l(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function A(e, t) {
          function r(o, i, a, s) {
            var u = f(e[o], e, i);
            if ("throw" !== u.type) {
              var l = u.arg,
                c = l.value;
              return c && "object" == typeof c && n.call(c, "__await") ? t.resolve(c.__await).then(function (e) {
                r("next", e, a, s);
              }, function (e) {
                r("throw", e, a, s);
              }) : t.resolve(c).then(function (e) {
                l.value = e, a(l);
              }, function (e) {
                return r("throw", e, a, s);
              });
            }
            s(u.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function value(e, n) {
              function o() {
                return new t(function (t, o) {
                  r(e, n, t, o);
                });
              }
              return i = i ? i.then(o, o) : o();
            }
          });
        }
        function I(t, r, n) {
          var o = d;
          return function (i, a) {
            if (o === h) throw Error("Generator is already running");
            if (o === y) {
              if ("throw" === i) throw a;
              return {
                value: e,
                done: !0
              };
            }
            for (n.method = i, n.arg = a;;) {
              var s = n.delegate;
              if (s) {
                var u = w(s, n);
                if (u) {
                  if (u === m) continue;
                  return u;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (o === d) throw o = y, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              o = h;
              var l = f(t, r, n);
              if ("normal" === l.type) {
                if (o = n.done ? y : p, l.arg === m) continue;
                return {
                  value: l.arg,
                  done: n.done
                };
              }
              "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
            }
          };
        }
        function w(t, r) {
          var n = r.method,
            o = t.iterator[n];
          if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, w(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
          var i = f(o, t.iterator, r.arg);
          if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
          var a = i.arg;
          return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
        }
        function x(e) {
          var t = {
            tryLoc: e[0]
          };
          1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
        }
        function b(e) {
          var t = e.completion || {};
          t.type = "normal", delete t.arg, e.completion = t;
        }
        function P(e) {
          this.tryEntries = [{
            tryLoc: "root"
          }], e.forEach(x, this), this.reset(!0);
        }
        function D(t) {
          if (t || "" === t) {
            var r = t[a];
            if (r) return r.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var o = -1,
                i = function r() {
                  for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                  return r.value = e, r.done = !0, r;
                };
              return i.next = i;
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return v.prototype = E, o(L, "constructor", {
          value: E,
          configurable: !0
        }), o(E, "constructor", {
          value: v,
          configurable: !0
        }), v.displayName = l(E, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
        }, t.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, E) : (e.__proto__ = E, l(e, u, "GeneratorFunction")), e.prototype = Object.create(L), e;
        }, t.awrap = function (e) {
          return {
            __await: e
          };
        }, O(A.prototype), l(A.prototype, s, function () {
          return this;
        }), t.AsyncIterator = A, t.async = function (e, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new A(c(e, r, n, o), i);
          return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
            return e.done ? e.value : a.next();
          });
        }, O(L), l(L, u, "Generator"), l(L, a, function () {
          return this;
        }), l(L, "toString", function () {
          return "[object Generator]";
        }), t.keys = function (e) {
          var t = Object(e),
            r = [];
          for (var n in t) r.push(n);
          return r.reverse(), function e() {
            for (; r.length;) {
              var n = r.pop();
              if (n in t) return e.value = n, e.done = !1, e;
            }
            return e.done = !0, e;
          };
        }, t.values = D, P.prototype = {
          constructor: P,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(b), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var r = this;
            function o(n, o) {
              return s.type = "throw", s.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var a = this.tryEntries[i],
                s = a.completion;
              if ("root" === a.tryLoc) return o("end");
              if (a.tryLoc <= this.prev) {
                var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");
                if (u && l) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                } else if (u) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                } else {
                  if (!l) throw Error("try statement without catch or finally");
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];
              if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), b(r), m;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];
              if (r.tryLoc === e) {
                var n = r.completion;
                if ("throw" === n.type) {
                  var o = n.arg;
                  b(r);
                }
                return o;
              }
            }
            throw Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, r, n) {
            return this.delegate = {
              iterator: D(t),
              resultName: r,
              nextLoc: n
            }, "next" === this.method && (this.arg = e), m;
          }
        }, t;
      }
      function Gr(e, t, r, n, o, i, a) {
        try {
          var s = e[i](a),
            u = s.value;
        } catch (e) {
          return void r(e);
        }
        s.done ? t(u) : Promise.resolve(u).then(n, o);
      }
      var kr = function kr() {
          return function (t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = arguments.length > 2 ? arguments[2] : void 0;
            try {
              var a;
              if (!i || !sessionStorage) return null;
              if (!t) throw F("get");
              var s,
                u = (r || {}).isPiiData,
                l = (r || {}).shouldParseJson,
                c = O(P, t, o, u);
              if (s = c.essential, u = c.piiData, !s && !x()) return null;
              var f = sessionStorage.getItem(t);
              if (u && null !== (a = f) && void 0 !== a && a.includes(n)) {
                var d = new RegExp("^".concat(n));
                f = R(f = f.replace(d, ""), e);
              }
              return l && (f = _(f)), f;
            } catch (e) {
              return !1;
            }
          }(me, {
            isPiiData: !0,
            shouldParseJson: !0
          }, o.ES);
        },
        jr = function jr(e) {
          e && M(ye, e, {
            isPiiData: !0,
            shouldStringifyJson: !0
          }, o.ES);
        },
        Wr = function Wr(e) {
          (null == e ? void 0 : e.length) > 0 && M(me, e, {
            isPiiData: !0,
            shouldStringifyJson: !0
          }, o.ES);
        },
        Br = function Br(e) {
          var t = S(),
            r = N(Le("dvid", t), void 0, o.ES),
            n = "",
            i = _e();
          null != i && i.vendorProfileType && (n = i.vendorProfileType);
          var a = {
            "mmt-auth": e,
            "user-identifier": Fr(r, e, n)
          };
          return null != i && i.xGoMMTClientId && (a["X-Gommt-Client-Id"] = null == i ? void 0 : i.xGoMMTClientId), Ne("userServiceUrl", "/ext/web/pwa/login", Ce, !0, a);
        };
      function Vr() {
        var e;
        return e = Mr().mark(function e(t, r) {
          var n, i, a, s, u, l, c, f, d;
          return Mr().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (void 0 === t && (t = !1), void 0 === r && (r = !0), n = S(), i = N(Le("mmt-auth", n), void 0, o.ES), (a = kr()) && i && (s = Nr(a, i)), !(a && i && s) || t) {
                  e.next = 11;
                  break;
                }
                if (!r) {
                  e.next = 10;
                  break;
                }
                return u = Cr(s), e.abrupt("return", null == u ? void 0 : u.userInfo);
              case 10:
                return e.abrupt("return", a);
              case 11:
                if (i) {
                  e.next = 13;
                  break;
                }
                throw Error("Application not Logged In");
              case 13:
                return e.prev = 13, e.next = 16, Br(i);
              case 16:
                if (l = e.sent, c = Ur(l), Wr(c), f = Nr(c, i), d = Cr(f), jr(null == d ? void 0 : d.userInfo), !r) {
                  e.next = 24;
                  break;
                }
                return e.abrupt("return", null == d ? void 0 : d.userInfo);
              case 24:
                return e.abrupt("return", c);
              case 27:
                throw e.prev = 27, e.t0 = e.catch(13), Error(e.t0);
              case 30:
              case "end":
                return e.stop();
            }
          }, e, null, [[13, 27]]);
        }), Vr = function Vr() {
          var t = this,
            r = arguments;
          return new Promise(function (n, o) {
            var i = e.apply(t, r);
            function a(e) {
              Gr(i, n, o, a, s, "next", e);
            }
            function s(e) {
              Gr(i, n, o, a, s, "throw", e);
            }
            a(void 0);
          });
        }, Vr.apply(this, arguments);
      }
      var Hr = {
        getUserInfoPIIClient: function getUserInfoPIIClient(e, t) {
          return Vr.apply(this, arguments);
        }
      };
    }(), s = s.default;
  }();
});